import type { ReactNode } from 'react';
import { type Sezione, usePuoAprire } from '../permessi.js';

/**
 * Un rimando verso un'altra sezione, che c'è solo per chi la apre.
 *
 * Chi guarda un documento vede il cliente e l'ordine a cui è attaccato; se il
 * suo livello non apre i clienti, il nome resta scritto ma non porta da
 * nessuna parte. Senza `altrimenti` non si vede niente.
 */
export function SeApre({
  sezione,
  children,
  altrimenti = null,
}: {
  sezione: Sezione;
  children: ReactNode;
  altrimenti?: ReactNode;
}) {
  const puo = usePuoAprire();
  return <>{puo(sezione) ? children : altrimenti}</>;
}
